import { EcoaFlax } from "@maven-rest/cdms/ecoa/Ecoa.flax";
import React, { useEffect, useState } from "react";
import { useStore } from "react-redux";
import { Redirect, RouteProps, Switch, useRouteMatch } from "react-router-dom";
import { useRequest } from "@coralblack/flax";
import { useLangContext } from "@layouts/home/LangContext";
import { Main } from "@layouts/Main";
import { useEcoaBreadcrumb } from "@hooks/useEcoaBreadcrumb";
import { StudySpecExcludeTriggers } from "maven-lib/dist/consts/edc";
import { RootState } from "maven-lib/dist/states";
import { CrfSpecContextProvider } from "./CrfSpecContext";
import { EcoaRoute } from "./routes/EcoaRoute";
import { AuthRoute } from "@maven-surface/components/common/AuthRoute";

const MemoizedEcoaRoute = React.memo(EcoaRoute);

interface EcoaLayoutProps extends RouteProps {}

export function EcoaLayout(props: EcoaLayoutProps) {
  useLangContext();

  const match = useRouteMatch();
  const { header, footer } = useEcoaBreadcrumb();
  const session = useStore<RootState>().getState().session;
  const [crfSpec, setCrfSpec] = useState<StudySpecExcludeTriggers | null>(null);

  const { request: getEcoaStudySpec, response } = useRequest(
    { ...EcoaFlax.getEcoaStudySpec({}) },
    {
      done: (data) => {
        if (data) setCrfSpec(data.studySpec);
      },
    }
  );

  useEffect(() => {
    getEcoaStudySpec();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (response.busy) {
    return null;
  }

  return (
    <>
      <CrfSpecContextProvider crfSpec={crfSpec}>
        <Main header={header} footer={footer}>
          <Switch>
            <AuthRoute session={session} denyRedirectTo="/" path={`${match.url}`} component={MemoizedEcoaRoute} />
            <Redirect from="*" to="/404?r=we" />
          </Switch>
        </Main>
      </CrfSpecContextProvider>
    </>
  );
}
